import { invokeApiGateway } from '../../auth/api-client';

export type DdbTable = string;

export interface DdbRecord {
  [key: string]: any;
}

export function getKeyFields(table: string): { label: string; key: string; required: boolean }[] {
  if (table === 'OutputCache') {
    return [
      { label: 'Advertiser ID', key: 'advertiserId', required: true },
      { label: 'Campaign ID', key: 'campaignId', required: false },
      { label: 'Marketplace ID', key: 'marketplaceId', required: false },
    ];
  }
  return [
    { label: 'Advertiser ID', key: 'advertiserId', required: true },
    { label: 'Marketplace ID', key: 'marketplaceId', required: false },
    { label: 'Campaign ID', key: 'campaignId', required: false },
  ];
}

export async function listTables(env: string) {
  return invokeApiGateway(`/debug/ddb/tables?env=${env.toLowerCase()}`);
}

export async function describeTable(env: string, tableName: string) {
  return invokeApiGateway(`/debug/ddb/${encodeURIComponent(tableName)}/describe?env=${env.toLowerCase()}`);
}

export async function queryDdb(
  env: string,
  params: { table: string; advertiserId: string; marketplaceId?: string; campaignId?: string },
): Promise<DdbRecord[]> {
  const data = await invokeApiGateway(`/debug/ddb/query?env=${env.toLowerCase()}`, 'POST', params);
  // API returns {records: {strategyMetadata: [...], actionRecords: [...], ...}}
  // Flatten all categories into a single array
  if (data.records && typeof data.records === 'object') {
    const all: DdbRecord[] = [];
    for (const [category, items] of Object.entries(data.records)) {
      if (Array.isArray(items)) {
        for (const item of items) {
          all.push({ _category: category, ...item });
        }
      }
    }
    return all;
  }
  // If it's already an array (e.g. output-cache)
  if (Array.isArray(data.items)) {
    return data.items;
  }
  if (Array.isArray(data.entries)) {
    return data.entries;
  }
  return [];
}
